<template>
	<div>
		<h1>Heti szobapontozás-áttekintés</h1>
		<v-row>
			<v-col cols="12" sm="11">
				<v-menu
					v-model="hetfovalaszto.menu"
					:close-on-content-click="false"
					transition="scale-transition"
					offset-y
					min-width="290px"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="hetfovalaszto.datum"
							label="Hét kezdőnapja"
							prepend-inner-icon="fa-calendar"
							readonly
							v-bind="attrs"
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker
						v-model="hetfovalaszto.datum"
						no-title
						scrollable
						:allowed-dates="hetfok"
						first-day-of-week="1"
						@input="hetfovalaszto.menu=false, tablazatfrissitese()"
					>
					</v-date-picker>
				</v-menu>
			</v-col>
			<v-col cols="12" sm="1">
				<v-tooltip top>
					<template v-slot:activator="{on, attrs}">
						<v-btn fab @click="dialogusok.ujszobapont.mutat=true" color="success" v-bind="attrs" v-on="on"><v-icon>fa-plus</v-icon></v-btn>
					</template>
					Új
				</v-tooltip>
			</v-col>
		</v-row>
		<v-data-table
			:items="adatok.szobak"
			:headers="tablazatok.szobapontozas.fejlec"
			sort-by="szobanev"
		>
			<template v-slot:item.szobanev="{item}">
				<v-tooltip top>
					<template v-slot:activator="{on,attrs}">
						<span v-on="on" v-bind="attrs">{{item.szobanev}}</span>
					</template>
					<span :key="lako.id" v-for="lako in adatok.felhasznalok.filter(f => f.szobaid==item.id)">
						{{lako.nev+" ("+(lako.csoportid? adatok.csoportok.find(cs => cs.id==lako.csoportid).csoportnev+" Csoportvezető: "+adatok.felhasznalok.find(f => f.id==adatok.csoportok.find(cs =>cs.id==lako.csoportid).csoportvezetoid).nev+", ": "")+adatok.minositesek.find(m =>m.id==lako.minosites).minositesnev+")"}},
					</span>
				</v-tooltip>

			</template>
			<template v-slot:item.hetfo="{item}">
				<v-chip color="success">Összeg: {{osszeg(item.id,hettetszolegesnapja(hetfovalaszto.datum,0))}}</v-chip>
				<v-tooltip top :key="pont.pontozasiszempontid" v-for="pont in adatok.szobapontozas.filter(p => p.szobaid==item.id&&p.nap==hettetszolegesnapja(hetfovalaszto.datum,0)).map(p => {
					return {
						...p,
						...adatok.szobapontozasiszempontok.find(sz => sz.id==p.pontozasiszempontid),
						nevelo: adatok.felhasznalok.find(f => f.id==p.neveloid).nev
					}
					})">
					<template v-slot:activator="{on, attrs}">
						<v-chip v-bind="attrs" v-on="on" color="primary" :close="pont.neveloid==$store.state.id||$store.state.minosites==-2" @click:close="ponttorlese(pont.szobaid,pont.pontozasiszempontid,hettetszolegesnapja(hetfovalaszto.datum,0))">{{pont.szempont}}: {{pont.pont}}</v-chip>
					</template>
					{{pont.leiras}} - {{pont.nevelo}}
				</v-tooltip>
			</template>
			<template v-slot:item.kedd="{item}">
				<v-chip color="success">Összeg: {{osszeg(item.id,hettetszolegesnapja(hetfovalaszto.datum,1))}}</v-chip>
				<v-tooltip top :key="pont.pontozasiszempontid" v-for="pont in adatok.szobapontozas.filter(p => p.szobaid==item.id&&p.nap==hettetszolegesnapja(hetfovalaszto.datum,1)).map(p => {
					return {
						...p,
						...adatok.szobapontozasiszempontok.find(sz => sz.id==p.pontozasiszempontid),
						nevelo: adatok.felhasznalok.find(f => f.id==p.neveloid).nev
					}
					})">
					<template v-slot:activator="{on, attrs}">
						<v-chip v-bind="attrs" v-on="on" color="primary" :close="pont.neveloid==$store.state.id||$store.state.minosites==-2" @click:close="ponttorlese(pont.szobaid,pont.pontozasiszempontid,hettetszolegesnapja(hetfovalaszto.datum,1))">{{pont.szempont}}: {{pont.pont}}</v-chip>
					</template>
					{{pont.leiras}} - {{pont.nevelo}}
				</v-tooltip>
			</template>
			<template v-slot:item.szerda="{item}">
				<v-chip color="success">Összeg: {{osszeg(item.id,hettetszolegesnapja(hetfovalaszto.datum,2))}}</v-chip>
				<v-tooltip top :key="pont.pontozasiszempontid" v-for="pont in adatok.szobapontozas.filter(p => p.szobaid==item.id&&p.nap==hettetszolegesnapja(hetfovalaszto.datum,2)).map(p => {
					return {
						...p,
						...adatok.szobapontozasiszempontok.find(sz => sz.id==p.pontozasiszempontid),
						nevelo: adatok.felhasznalok.find(f => f.id==p.neveloid).nev
					}
					})">
					<template v-slot:activator="{on, attrs}">
						<v-chip v-bind="attrs" v-on="on" color="primary" :close="pont.neveloid==$store.state.id||$store.state.minosites==-2" @click:close="ponttorlese(pont.szobaid,pont.pontozasiszempontid,hettetszolegesnapja(hetfovalaszto.datum,2))">{{pont.szempont}}: {{pont.pont}}</v-chip>
					</template>
					{{pont.leiras}} - {{pont.nevelo}}
				</v-tooltip>
			</template>
			<template v-slot:item.csutortok="{item}">
				<v-chip color="success">Összeg: {{osszeg(item.id,hettetszolegesnapja(hetfovalaszto.datum,3))}}</v-chip>
				<v-tooltip top :key="pont.pontozasiszempontid" v-for="pont in adatok.szobapontozas.filter(p => p.szobaid==item.id&&p.nap==hettetszolegesnapja(hetfovalaszto.datum,3)).map(p => {
					return {
						...p,
						...adatok.szobapontozasiszempontok.find(sz => sz.id==p.pontozasiszempontid),
						nevelo: adatok.felhasznalok.find(f => f.id==p.neveloid).nev
					}
					})">
					<template v-slot:activator="{on, attrs}">
						<v-chip v-bind="attrs" v-on="on" color="primary" :close="pont.neveloid==$store.state.id||$store.state.minosites==-2" @click:close="ponttorlese(pont.szobaid,pont.pontozasiszempontid,hettetszolegesnapja(hetfovalaszto.datum,3))">{{pont.szempont}}: {{pont.pont}}</v-chip>
					</template>
					{{pont.leiras}} - {{pont.nevelo}}
				</v-tooltip>
			</template>
			<template v-slot:item.pentek="{item}">
				<v-chip color="success">Összeg: {{osszeg(item.id,hettetszolegesnapja(hetfovalaszto.datum,4))}}</v-chip>
				<v-tooltip top :key="pont.pontozasiszempontid" v-for="pont in adatok.szobapontozas.filter(p => p.szobaid==item.id&&p.nap==hettetszolegesnapja(hetfovalaszto.datum,4)).map(p => {
					return {
						...p,
						...adatok.szobapontozasiszempontok.find(sz => sz.id==p.pontozasiszempontid),
						nevelo: adatok.felhasznalok.find(f => f.id==p.neveloid).nev
					}
					})">
					<template v-slot:activator="{on, attrs}">
						<v-chip v-bind="attrs" v-on="on" color="primary" :close="pont.neveloid==$store.state.id||$store.state.minosites==-2" @click:close="ponttorlese(pont.szobaid,pont.pontozasiszempontid,hettetszolegesnapja(hetfovalaszto.datum,4))">{{pont.szempont}}: {{pont.pont}}</v-chip>
					</template>
					{{pont.leiras}} - {{pont.nevelo}}
				</v-tooltip>
			</template>
		</v-data-table>

		<v-dialog
				v-model="dialogusok.ujszobapont.mutat"
				persistent
				max-width="600px"
		>

				<v-card>
					<v-card-title>
						<span class="headline" v-if="dialogusok.ujszobapont.mutat">Új pont</span>
					</v-card-title>
					<v-card-text>
						<v-container>
							<v-select
								prepend-inner-icon="fa-calendar-day"
								label="Nap"
								:items="[{nap: 'Hétfő', szam: 0},{nap: 'Kedd', szam: 1},{nap: 'Szerda', szam: 2},{nap: 'Csütörtök', szam: 3},{nap: 'Péntek', szam: 4}]"
								item-value="szam"
								item-text="nap"
								v-model="dialogusok.ujszobapont.nap"
							></v-select>
							<v-select
								prepend-inner-icon="fa-bed"
								label="Szoba"
								:items="adatok.szobak"
								item-value="id"
								item-text="szobanev"
								v-model="dialogusok.ujszobapont.szobaid"
							>
								<template v-slot:item="{item}">
									<v-tooltip top>
										<template v-slot:activator="{on,attrs}">
											<span v-on="on" v-bind="attrs">{{item.szobanev}}</span>
										</template>
										<span v-for="lako in adatok.felhasznalok.filter(f => f.szobaid==item.id)">
											{{lako.nev+" ("+(lako.csoportid? adatok.csoportok.find(cs => cs.id==lako.csoportid).csoportnev+" Csoportvezető: "+adatok.felhasznalok.find(f => f.id==adatok.csoportok.find(cs =>cs.id==lako.csoportid).csoportvezetoid).nev+", ": "")+adatok.minositesek.find(m =>m.id==lako.minosites).minositesnev+")"}},
										</span>
									</v-tooltip>
								</template>

							</v-select>
							<v-select
								v-if="dialogusok.ujszobapont.szobaid>-1"
								prepend-inner-icon="fa-broom"
								label="Szempont"
								:items="adatok.szobapontozasiszempontok.filter(szpsz => adatok.szobapontozas.findIndex(szp => szp.szobaid==dialogusok.ujszobapont.szobaid&&szp.nap==hettetszolegesnapja(hetfovalaszto.datum,dialogusok.ujszobapont.nap) &&szp.pontozasiszempontid==szpsz.id)==-1)"
								v-model="dialogusok.ujszobapont.szempont"
								item-value="id"
								item-text="szempont"
							>
								<template v-slot:item="{item}">
									<v-tooltip top>
										<template v-slot:activator="{on,attrs}">
											<v-span v-bind="attrs" v-on="on">{{item.szempont}}: {{item.pont}}</v-span>
										</template>
										{{item.leiras}}
									</v-tooltip>
								</template>
							</v-select>

						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="blue darken-1"
							text
							@click="dialogusok.ujszobapont.mutat=false"
						>
							Mégsem<v-icon>fa-times</v-icon>
						</v-btn>
						<v-btn
							color="success"
							text
							v-if=""
							@click="ujszobapont"
						>
							Hozzáadás<v-icon>fa-plus</v-icon>
						</v-btn>
					</v-card-actions>
				</v-card>
		</v-dialog>
		<v-snackbar
		 v-model="snackbar.megnyit"
		>
		 {{ snackbar.szoveg }}
		 <v-btn
			 color="pink"
			 text
			 @click="snackbar.megnyit = false"
		 >
			 Bezár
		 </v-btn>
		</v-snackbar>
	</div>
</template>

<script>
	import router from '../router';
	export default {
		data: function(){
			return {
				hetfovalaszto: {
					datum: this.aktualishetfo(),
					menu: false
				},
        snackbar: {
          megnyit: false,
          szoveg: ""
        },
        tablazatok: {
					szobapontozas: {
						fejlec: [
							{
								text: "Szoba",
								value: "szobanev",
								align: "center",
								groupable: false,
								sortable: true,
								filterable: false
							},
							{
								text: "Hétfő",
								value: "hetfo",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "Kedd",
								value: "kedd",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "Szerda",
								value: "szerda",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "Csütörtök",
								value: "csutortok",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							},
							{
								text: "Péntek",
								value: "pentek",
								align: "center",
								groupable: false,
								sortable: false,
								filterable: false
							}
						]
					}
        },
        dialogusok: {
					ujszobapont: {
						mutat: false,
						szobaid: -1,
						szempont: -1,
						nap: 0
					}
        },
        adatok: {}
      }
		},
		computed: {

		},
		watch: {

		},
		methods: {
			ponttorlese: function(szobaid,pontozasiszempontid,nap){
				this.axios.delete(this.$store.state.backendeleres+"szobapontozas/ponttorlese/"+nap+"/"+szobaid+"/"+pontozasiszempontid)
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) {
											this.adatok.szobapontozas.splice(this.adatok.szobapontozas.findIndex(szp => szp.szobaid==szobaid&&szp.pontozasiszempontid==pontozasiszempontid&&szp.nap==nap),1);
											this.snackbar.szoveg="A törlés sikeresen megtörtént";
											this.snackbar.mutat=true;
										}
										else{
											this.snackbar.szoveg="A törlés hibába ütközött: "+response.data.hiba;
											this.snackbar.mutat=true;
										}
									})
			},
			ujszobapont: function() {
				this.axios.post(this.$store.state.backendeleres+"szobapontozas/ujszobapont",{szobaid: this.dialogusok.ujszobapont.szobaid, pontozasiszempontid: this.dialogusok.ujszobapont.szempont, nap: this.hettetszolegesnapja(this.hetfovalaszto.datum,this.dialogusok.ujszobapont.nap)})
									.then((response) => {
										if(response.data.bejelentkezve==false)this.kijelentkezes();
										if(response.data.ok) {
											this.adatok.szobapontozas.push({szobaid: this.dialogusok.ujszobapont.szobaid, pontozasiszempontid: this.dialogusok.ujszobapont.szempont, neveloid: this.$store.state.id, nap: this.hettetszolegesnapja(this.hetfovalaszto.datum,this.dialogusok.ujszobapont.nap)})
											this.snackbar.szoveg="A pontozás sikeresen megtörtént";
											this.snackbar.mutat=true;
											this.dialogusok.ujszobapont.mutat=false
										}
										else{
											this.snackbar.szoveg="A pontozás hibába ütközött: "+response.data.hiba;
											this.snackbar.mutat=true;
										}
									})
			},
			tablazatfrissitese: function() {
				this.axios.get(this.$store.state.backendeleres+"szobapontozas/"+this.hetfovalaszto.datum+"/"+this.hettetszolegesnapja(this.hetfovalaszto.datum,4)).then((response) => {
					if(response.data.ok){
	          this.adatok=response.data.adatok;
					}
	        if(response.data.bejelentkezve== false) this.kijelentkezes();
				})
			},
			aktualishetfo: () => {var d = new Date(); var r = new Date(d.setDate(d.getDate()-d.getDay()+(d.getDay() == 0 ? -6:1))); return r.toISOString().substring(0,10)},
			hetfok: nap => new Date(Date.parse(nap)).getDay()==1,
			hettetszolegesnapja: function(hetfo, nap /*0: hétfő, 1: kedd*/)  {
				var datum = new Date(Date.parse(hetfo))
				datum.setDate(datum.getDate()+nap)
				return datum.toISOString().substring(0,10)
			},
			osszeg: function(szoba, nap) {
				var osszeg =this.adatok.alapszobapont;
				this.adatok.szobapontozas.filter(p => p.nap==nap&&p.szobaid==szoba).forEach(p => {
					osszeg+=this.adatok.szobapontozasiszempontok.find(szp => szp.id==p.pontozasiszempontid).pont
				})
				return osszeg;
			}

		},
		mounted(){
			this.tablazatfrissitese();
		}
	}
</script>
